import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {
    AccountCurrencies,
    Address,
    AuthorisedSignatory,
    BusinessCustomerInformation,
    ContactInformation,
    CorporateAccount,
    CorporateAccountAttachments,
    CorporateProfileAttachments,
    Directors,
    ExpectedTurnover,
    InitialDeposits,
    Introducer,
    RegisteredOfficeAddress,
    Shareholders,
    StatementAffairs,
    UsageReferral
} from '../entity';

@Injectable()
export class CorporateAccountsService {

    constructor(private _http: Http) {
    }

    getCorporateAccount(id: number): Observable<CorporateAccount> {
        return this._http.get('/api/backoffice/corporate-accounts/' + id)
            .map(response => response.json())
    }

    getCorporateAccountAttachments(id: number): Observable<CorporateAccountAttachments> {
        return this._http.get(`/api/backoffice/corporate-accounts/${id}/attachments`)
            .map(response => response.json());
    }

    getCorporateProfileAttachments(profileId: number): Observable<CorporateProfileAttachments> {
        return this._http.get(`/api/backoffice/corporate-accounts/${profileId}/attachments/all`)
            .map(response => response.json());
    }

    updateBusinessCustomerInformation(profileId: number, businessCustomerInformation: BusinessCustomerInformation): Observable<BusinessCustomerInformation> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/business-customer-information`, businessCustomerInformation)
            .map(response => response.json());
    }

    updateRegisteredOfficeAddress(profileId: number, registeredOfficeAddress: RegisteredOfficeAddress): Observable<RegisteredOfficeAddress> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/registered-office-address`, registeredOfficeAddress)
            .map(response => response.json());
    }

    updateOfficialBusinessLocation(profileId: number, officialBusinessLocation: Address): Observable<Address> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/official-business-location`, officialBusinessLocation)
            .map(response => response.json());
    }

    updateContactInformation(profileId: number, contactInformation: ContactInformation): Observable<ContactInformation> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/contact-information`, contactInformation)
            .map(response => response.json());
    }

    updateStatementAffairs(profileId: number, statementAffairs: StatementAffairs): Observable<StatementAffairs> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/statement-of-affairs`, statementAffairs)
            .map(response => response.json());
    }

    updateInitialDeposit(profileId: number, initialDeposits: InitialDeposits): Observable<InitialDeposits> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/initial-deposit`, initialDeposits)
            .map(response => response.json());
    }

    updateExpectedTurnover(profileId: number, expectedTurnover: ExpectedTurnover): Observable<ExpectedTurnover> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/expected-turnover`, expectedTurnover)
            .map(response => response.json());
    }

    updateAuthorisedSignatory(profileId: number, authorisedSignatory: AuthorisedSignatory): Observable<AuthorisedSignatory> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/authorised-signatory`, authorisedSignatory)
            .map(response => response.json());
    }

    updateDirectors(profileId: number, directors: Directors): Observable<Directors> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/directors`, directors)
            .map(response => response.json());
    }

    updateShareholders(profileId: number, shareholders: Shareholders): Observable<Shareholders> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/shareholders`, shareholders)
            .map(response => response.json());
    }

    updateIntroducer(profileId: number, introducer: Introducer): Observable<Introducer> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/introducer`, introducer)
            .map(response => response.json());
    }

    updateAccountCurrencies(profileId: number, accountCurrencies: AccountCurrencies): Observable<AccountCurrencies> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/account-currencies`, accountCurrencies)
            .map(response => response.json());
    }

    updateUsageReferral(profileId: number, usageReferral: UsageReferral): Observable<UsageReferral> {
        return this._http.patch(`/api/backoffice/corporate-accounts/${profileId}/usage-and-referral`, usageReferral)
            .map(response => response.json());
    }

    updateLegalDocStatus(idDB: number, status: boolean): Observable<any> {
        return this._http.patch(`/api/backoffice/corporate-accounts/update-doc-status`, {
            idDB: idDB,
            status: status
        })
            .map(response => response.json());
    }

    getLegalDocStatus(idDb: number): Observable<boolean> {
        return this._http.get(`/api/backoffice/corporate-accounts/${idDb}/get-doc-status`)
            .map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/corporate-accounts.service.ts